"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoaderContainer = exports.CrossButton = exports.TotalPrice = exports.TotalPriceBlock = exports.PkgDescription = exports.AmountBlock = exports.InStockAmount = exports.StockAmountBlock = exports.PkgAmountBlock = exports.PkgAmount = exports.PriceUnit = exports.Price = exports.PriceBlock = exports.Container = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const Typography_1 = __importDefault(require("../../../UI/Typography"));
const Types_1 = require("Types");
const svg_components_1 = require("../../../../assets/svg-components");
exports.Container = styled_components_1.default.div `
  ${props => props.variantType === Types_1.VariantTypes.FULL_VIEW &&
    `padding: ${props.theme.spacing.m5}px 0; display: flex; justify-content: space-between; border-bottom: 1px solid ${props.theme.palette.DARK_GRAY_20};`}
  ${props => props.variantType === Types_1.VariantTypes.MINI_CART_VIEW &&
    `padding: ${props.theme.spacing.s5}px 0; display: flex; justify-content: space-between; border-bottom: 1px solid ${props.theme.palette.DARK_GRAY_20};`}
    ${props => props.variantType === Types_1.VariantTypes.CAROUSEL_VIEW &&
    `display: flex; flex-direction: column; justify-content: space-between; align-items: center; height: 100%;`}
  width: 100%;
  position: relative;

  @media (max-width: ${props => props.theme.breakpoints.md}px) {
    ${props => props.variantType === Types_1.VariantTypes.FULL_VIEW &&
    `
      flex-direction: column;
      padding: ${props.theme.spacing.s5}px 0 ${props.theme.spacing.l1}px 0;
    `}
  }
`;
exports.PriceBlock = styled_components_1.default.div `
  ${props => props.variantType === Types_1.VariantTypes.CAROUSEL_VIEW && `width: 100%; margin-top: ${props.theme.spacing.m3}px;`}
  margin-bottom: ${props => props.theme.spacing.s2}px;
`;
exports.Price = (0, styled_components_1.default)(Typography_1.default) `
  ${props => (props.variantType === Types_1.VariantTypes.CAROUSEL_VIEW || props.variantType === Types_1.VariantTypes.FULL_VIEW) &&
    `color: ${props.theme.palette.LIGHT_BLACK};`}
  ${props => props.variantType === Types_1.VariantTypes.MINI_CART_VIEW && `color: ${props.theme.palette.DARK_GRAY_100};`}
  display: inline-block;
  margin: 0;
`;
exports.PriceUnit = (0, styled_components_1.default)(Typography_1.default) `
  margin: 0;
  color: ${props => props.theme.palette.LIGHT_BLACK};
`;
exports.PkgAmount = (0, styled_components_1.default)(Typography_1.default) `
  ${props => (props.variantType === Types_1.VariantTypes.CAROUSEL_VIEW || props.variantType === Types_1.VariantTypes.FULL_VIEW) &&
    `color: ${props.theme.palette.LIGHT_BLACK};`}
  ${props => props.variantType === Types_1.VariantTypes.MINI_CART_VIEW && `color: ${props.theme.palette.DARK_GRAY_100};`}
  display: inline-block;
`;
exports.PkgAmountBlock = styled_components_1.default.div `
  display: flex;
  flex-direction: row;
  align-items: flex-end;

  margin-bottom: ${props => props.theme.spacing.s2}px;
  > h5 {
    margin-right: ${props => props.theme.spacing.s1}px;
  }
  > div {
    margin-left: ${props => props.theme.spacing.s1}px;
  }
`;
exports.StockAmountBlock = styled_components_1.default.div `
  display: flex;
  align-items: center;
  ${props => props.variantType === Types_1.VariantTypes.FULL_VIEW && `margin-bottom: ${props.theme.spacing.s2}px;`}
  ${props => props.variantType === Types_1.VariantTypes.CAROUSEL_VIEW && `margin-bottom: ${props.theme.spacing.s4}px;`}
  > svg {
    margin-right: ${props => props.theme.spacing.s2}px;
  }

  @media (max-width: ${props => props.theme.breakpoints.md}px) {
    ${props => props.variantType === Types_1.VariantTypes.FULL_VIEW &&
    `
      margin-bottom: ${props.theme.spacing.s4}px;
    `}
  }
`;
exports.InStockAmount = (0, styled_components_1.default)(Typography_1.default) `
  display: inline-block;
  color: ${props => props.theme.palette.LIGHT_BLACK};
`;
exports.AmountBlock = styled_components_1.default.div `
  display: flex;
  ${props => props.variantType === Types_1.VariantTypes.MINI_CART_VIEW && `flex-direction: column;`}
  ${props => props.variantType === Types_1.VariantTypes.CAROUSEL_VIEW && `justify-content: space-between;`}
  > button {
    white-space: nowrap;
    margin-left: ${props => props.theme.spacing.s4}px;
    padding: ${props => props.theme.spacing.s3}px ${props => props.theme.spacing.m1}px;

    @media (max-width: ${props => props.theme.breakpoints.md}px) {
      ${props => props.variantType === Types_1.VariantTypes.FULL_VIEW &&
    `
      width: ${props.theme.constants.addToCart.buttonWidth}px;
    `}
    }
  }
`;
exports.PkgDescription = (0, styled_components_1.default)(Typography_1.default) `
  margin-bottom: ${props => props.theme.spacing.s2}px;
  color: ${props => props.theme.palette.DARK_GRAY_80};
`;
exports.TotalPriceBlock = styled_components_1.default.div `
  margin-top: ${props => props.theme.spacing.s4}px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
exports.TotalPrice = (0, styled_components_1.default)(Typography_1.default) `
  color: ${props => props.theme.palette.LIGHT_BLACK};
  user-select: none;
`;
exports.CrossButton = (0, styled_components_1.default)(svg_components_1.CrossIcon) `
  cursor: pointer;
`;
exports.LoaderContainer = styled_components_1.default.div `
  background: ${props => props.theme.palette.BW_100};
  opacity: 0.9;
  position: absolute;
  width: 100%;
  height: 85%;
  display: flex;
  justify-content: center;
  padding: ${props => props.theme.spacing.s5}px 0;
  z-index: 20;
`;
exports.default = {
    Container: exports.Container,
    Price: exports.Price,
    PkgAmount: exports.PkgAmount,
    InStockAmount: exports.InStockAmount,
    PkgAmountBlock: exports.PkgAmountBlock,
    StockAmountBlock: exports.StockAmountBlock,
    AmountBlock: exports.AmountBlock,
    TotalPriceBlock: exports.TotalPriceBlock,
    TotalPrice: exports.TotalPrice,
    CrossButton: exports.CrossButton,
    LoaderContainer: exports.LoaderContainer
};
